import {
    Switch,
    Route,
    useRouteMatch,
    Redirect
} from "react-router-dom";

import Playlists from 'views/Collection/Playlists'
import Albums from 'views/Collection/Albums'
import Artists from 'views/Collection/Artists'
import Podcasts from 'views/Collection/Podcasts'
import Tracks from 'views/Collection/Tracks'

export default function Collection() {

    let match = useRouteMatch("/collection");

    if (match.isExact) {
        return <Redirect to="/collection/playlists" />
    }

    return (
        <Switch>
            <Route path="/collection/playlists">
                <Playlists />
            </Route>
            <Route path="/collection/podcasts">
                <Podcasts />
            </Route>
            <Route path="/collection/artists">
                <Artists />
            </Route>
            <Route path="/collection/albums">
                <Albums />
            </Route>
            <Route path="/collection/tracks">
                <Tracks />
            </Route>
        </Switch>
    )
}
